exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-view__block[data-v-084466c1]{height:.35rem;width:.875rem}.card-view__block--top[data-v-084466c1]{margin-bottom:.2rem}.view[data-v-084466c1]{height:1.55rem;padding:.2rem}.view--list[data-v-084466c1]{height:1.55rem;padding:0 .2rem}", ""]);

// exports
